module.exports = __webpack_public_path__ + "img/HK_Phone.64221f43.png";